<template>
  <b-container 
    v-if="oplevering" 
    fluid
  >
    <b-card-text>
      Doe op basis van de actuele prognose een oplevering. Vink hieronder af
      welke werkzaamheden gedaan zijn en laat open wat niet is uitgevoerd.
      Opleverpunten kunnen per onderdeel worden aangemaakt.
    </b-card-text>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Formulier van oplevering</b-card-title>
        <b-card-sub-title>{{ opleverUrl }}</b-card-sub-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col 
            cols="12"
          >
            <b-form-row class="mb-4">
              <b-col>
                <b-input-group 
                  size="lg" 
                  prepend="Werkzaamheden in" 
                >
                  <b-input 
                    v-model.number="oplevering.oplever_jaar" 
                    type="number"
                  />
                </b-input-group>
              </b-col>
              <b-col>
                <b-datepicker
                  v-model="oplevering.datum"
                  size="lg" 
                />
              </b-col>
            </b-form-row>
            <b-form-radio-group
              v-if="oplevering.omschrijving == null" 
              v-model="oplevering.omschrijving"
              :options="['Planmatig','Nieuwbouw','Anders, nl.']"
              buttons
              size="lg"
              class="mb-4"
            />
            <b-textarea 
              v-else
              v-model="oplevering.omschrijving" 
              placeholder="Omschrijving" 
              class="mb-4"
            />


            <b-button 
              class="pull-right" 
              variant="primary" 
              @click="inklappenAlles"
            >
              <font-awesome-icon icon="chevron-up" /> Alles inklappen
            </b-button>

            <b-table
              :busy="busy"
              :caption="opleverUrl"
              :items="checklist"
              :fields="['Checklist']"
              :tbody-tr-class="tbodyTrClass"
              bordered
              striped
            >
              <template #cell(Checklist)="row">
                <b-form-checkbox
                  v-if="row.item.element"
                  :checked="isUitgeklapt(row.item)"
                  switch
                  class="pull-right"
                  @click.native.prevent="toggleUitgeklapt(row.item)"
                />

                <h4 @click="toggleUitgeklapt(row.item)">
                  {{ row.item.titel }}
                </h4> 

                <!--
                  Let op: `checklist` is een computed die bij elke herberekening
                  compleet nieuwe rij-objecten aanmaakt (zie getPrognoseResultaat).
                  Bootstrap-vue's eigen `_showDetails`/`toggleDetails`-mechanisme
                  (via de `#row-details` slot) zet die vlag op dat wegwerp-object,
                  waardoor de uitklapstatus verloren gaat zodra de checklist
                  opnieuw wordt berekend. Daarom houden we de uitklapstatus hier
                  zelf bij (`uitgeklapt`), gekoppeld aan een stabiele sleutel
                  (het onderliggende `onderdeel`), in plaats van te vertrouwen
                  op item-identiteit binnen de tabel.
                -->
                <b-form-row v-if="row.item.element && isUitgeklapt(row.item)">
                  <template v-if="row.item.onderdeel.elementId">
                    <b-col>
                      <b-card-img 
                        v-if="row.item.onderdeel.foto" 
                        :src="row.item.onderdeel.foto.secure_url"
                      >
                        <b-button />
                      </b-card-img>

                      <KiesFoto 
                        :path="`${$route.params.id}/img`" 
                        @foto-select="$set(row.item.onderdeel, 'foto', $event)"
                      />
                    </b-col>
                    <b-col>
                      <ElementCard
                        :title="elementen[row.item.onderdeel.elementId].Naam"
                        :form="elementen[row.item.onderdeel.elementId].Form"
                        :data="inventarisatie"
                      />
                    </b-col>
                  </template>
                  <template v-else>
                    Geen element gekoppeld!
                  </template>
                </b-form-row>

                <b-list-group>
                  <b-list-group-item
                    v-for="(a, index) in row.item.resultaat.acties.filter((a) =>
                      a.oplevering.includes(opleveringVanJaar)
                    )"
                    :key="`${index}-actie-${row.index}`"
                  >
                    <!--- {{ a.actie.jaren }} --->
                    <b-check
                      :checked="hasUitvoering(a.actie, opleveringVanJaar)"
                      size="lg"
                      @change="
                        (val) => editUitvoering(a.actie, opleveringVanJaar, val)
                      "
                    >
                      {{ a.actie.werkzaamheden }}
                      <b-button
                        size="sm"
                        @click="() => addNote(a.actie.werkzaamheden)"
                      >
                        <font-awesome-icon icon="plus" /> opmerking
                      </b-button>
                    </b-check>
                  </b-list-group-item>
                  <b-list-group-item
                    v-for="(g, index) in row.item.resultaat.gebreken.filter(
                      (g) => g.jaar == opleveringVanJaar
                    )"
                    :key="`${index}-gebrek-${row.index}`"
                  >
                    <b-check 
                      v-model="g.uitgevoerd" 
                      size="lg"
                    >
                      {{ g.werkzaamheden }}
                      <b-button
                        size="sm"
                        @click="
                          () => addNote(g.werkzaamheden)
                        "
                      >
                        <font-awesome-icon icon="plus" /> opmerking
                      </b-button>
                    </b-check>
                  </b-list-group-item>
                </b-list-group>
              </template>
            </b-table>
            <b-button 
              class="pull-right" 
              variant="primary" 
              @click="inklappenAlles"
            >
              <font-awesome-icon icon="chevron-up" /> Alles inklappen
            </b-button>
          </b-col>

          <b-col ref="opmerkingen">
            <b-table
              :fields="['opmerking']"
              :items="oplevering.notes"
              bordered
              striped
            >
              <template #cell(opmerking)="row">
                <b-input-group>
                  <b-button
                    variant="ghost-danger"
                    size="lg"
                    @click="() => oplevering.notes.splice(row.index, 1)"
                  >
                    <font-awesome-icon 
                      icon="trash"
                    />
                  </b-button>
                  <b-textarea
                    v-model="row.item.opmerking"
                    rows="2"
                    cols="30"
                    placeholder="Opmerking"
                  />
                </b-input-group>
              </template>
              
              <template #row-details="row">
                <b-card-group>
                  <b-card 
                    v-for="(foto,index) in row.item.media" 
                    :key="index" 
                    no-body 
                    class="mb-3"
                  >
                    <b-img 
                      :src="foto.secure_url" 
                      thumbnail
                      width="100"
                      height="100"
                    />
                    <b-card-body>
                      <b-button-toolbar class="icon pull-right">
                        <b-button
                          size="sm"
                          class="mx-2"
                          variant="danger"
                          @click="row.item.media.splice(index,1)"
                        >
                          <i class="fa fa-trash" />
                        </b-button>
                      </b-button-toolbar>
                      {{ foto.created_at | formatDateTime }}
                      <br>
                      <small>{{ foto.public_id.substring(0,30)+".." }}</small>
                    </b-card-body>
                  </b-card>
                </b-card-group>
                <KiesFoto 
                  :path="`${$route.params.id}/oplevering`" 
                  @foto-select="row.item.media.push($event)"
                />
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <b-form-row>
          <b-col>
            <Handtekening 
              key="Auditor_Handtekening"
              :value="oplevering.digitale_handtekening.auditor"
              :names="['Roel','Nick']"
              @input="$set(oplevering,'digitale_handtekening',{...oplevering.digitale_handtekening,auditor:$event})"
            >
              Auditor
            </Handtekening>
          </b-col>
          <b-col>
            <Handtekening 
              key="Installateur_Handtekening"
              :value="oplevering.digitale_handtekening.installateur"
              :names="['Installateur 1','Installateur 2']"
              @input="$set(oplevering,'digitale_handtekening',{...oplevering.digitale_handtekening,installateur:$event},)"
            >
              Installateur
            </Handtekening>
          </b-col>   
        </b-form-row>

        <b-check 
          v-model="confirmOplevering" 
          class="my-3" 
          switch 
          size="lg"
        >
          Bevestiging van oplevering
        </b-check>

        <b-alert
          :show="confirmOplevering && !heeftAuditorHandtekening"
          variant="warning"
        >
          <font-awesome-icon icon="exclamation-triangle" />
          Er ontbreekt een handtekening van de auditor. Een oplevering kan pas
          bevestigd worden nadat de auditor heeft getekend. Na bevestiging
          kan het rapport niet meer worden aangepast.
        </b-alert>

        <b-button
          :variant="confirmOplevering ? 'primary' : 'success'"
          :disabled="confirmOplevering && !heeftAuditorHandtekening"
          :size="confirmOplevering ? 'lg' : 'md'"
          @click="saveOplevering"
        >
          <font-awesome-icon icon="save" />
          {{ confirmOplevering ? "Opslaan &amp; verwerken" : "Opslaan" }}
        </b-button>
      </b-card-footer>
    </b-card>
  </b-container>
</template>

<script>
import { prognoseMixin } from "@/mixins/prognoseMixin";
import { serviceMixin } from "@/mixins/serviceMixin";
import { unitTabMixin } from "@/mixins/unitMixin";
import { VueSignaturePad } from "vue-signature-pad";
import Handtekening from "../../components/Handtekening.vue";
import { elementenMixin } from "@/mixins/elementenMixin";
import KiesFoto from '../../components/KiesFoto.vue';
import ElementCard from '../../components/ElementCard.vue';

export default {
  name: "TabOplevering",
  components: {
    VueSignaturePad,
    Handtekening,
    KiesFoto,
    ElementCard
},
  mixins: [serviceMixin, unitTabMixin, prognoseMixin,elementenMixin],
  props: {
    unit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      type: null,
      oplevering: null,
      busy: false,
      confirmOplevering: false,
      // Uitklapstatus per checklist-item, bijgehouden op een stabiele sleutel
      // (zie toelichting bij elementKey). Losstaand van bootstrap-vue's eigen
      // `_showDetails`, omdat de checklist-rijen bij elke herberekening
      // vervangen worden door nieuwe objecten.
      uitgeklapt: {},
    };
  },
  computed: {
    opleveringVanJaar: function () {
      return this.oplevering.oplever_jaar
    },
    list: function () {
      return this.checklist.map((r) => {
        return {
          titel: r.titel,
          items: r.resultaat.acties
            .filter((a) => a.jaren.includes(this.opleveringVanJaar))
            .map((a1) => {
              return { titel: a1.actie.werkzaamheden, checked: this.hasUitvoering(a1.actie, this.opleveringVanJaar) };
            })
            .concat(
              r.resultaat.gebreken
                .filter((g) => g.jaar == this.opleveringVanJaar)
                .map((g1) => {
                  return { titel: g1.omschrijving + ": " + g1.werkzaamheden,
                 checked: g1.uitgevoerd || false };
                })
            ),
        };
      });
    },
    config: function () {
      return {
        jaren: 80,
        jaar: this.opleveringVanJaar,
        showModeratorPanel: false,
        bouwjaar: this.bouwjaar,
        smalltable: true,
        modus: "Positie",
        footClone: false,
      };
    },
    onderdelen: function () {
      return this.oplevering ? this.oplevering.inspectiedata.onderdelen : [];
    },
    checklist: function () {
      return this.resultaat.prognose.rijen.filter((r) => {
        if (r.element) return true;
        var acties = r.resultaat.acties.filter((a) =>
          a.jaren.includes(this.opleveringVanJaar)
        );
        var gebreken = r.resultaat.gebreken.filter(
          (g) => g.jaar == this.opleveringVanJaar
        );
        return acties.length > 0 || gebreken.length > 0;
      });
    },
    bouwjaar: function () {
      return this.unit.Bouwjaar;
    },
    resultaat: function () {
      return {
        prognose: this.getPrognoseResultaat(this.rows),
      };
    },
    opleverUrl: function () {
      return "/unit/" + this.$props.unit.Id + "/oplevering";
    },
    heeftAuditorHandtekening: function () {
      var auditor =
        this.oplevering &&
        this.oplevering.digitale_handtekening &&
        this.oplevering.digitale_handtekening.auditor;
      return !!(auditor && auditor.png);
    },
  },
  mounted() {
    this.getOplevering();
    this.loadElementen(); // element formulieren
    this.loadInventarisatie(); // inventarisatie gegevens van de unit
  },
  methods: {
    elementKey(item) {
      return (item.onderdeel && item.onderdeel.elementId) || item.titel;
    },
    isUitgeklapt(item) {
      return !!this.uitgeklapt[this.elementKey(item)];
    },
    toggleUitgeklapt(item) {
      var key = this.elementKey(item);
      this.$set(this.uitgeklapt, key, !this.uitgeklapt[key]);
    },
    inklappenAlles() {
      this.uitgeklapt = {};
    },
    addNote(start) {
      console.log("add note");
      this.scrollToOpmerkingen();
      this.oplevering.notes.push({ opmerking: start, media: [],_showDetails:true });
    },
    hasUitvoering(actie, jaar) {
      var j = actie.jaren.find((j) => j.jaar == jaar);
      return j ? j.uitgevoerd : false;
    },
    editUitvoering(actie, jaar, uitgevoerd) {
      var j = actie.jaren.find((j) => j.jaar == jaar);
      if (j) j.uitgevoerd = uitgevoerd;
      if (!j) actie.jaren.push({ jaar: jaar, uitgevoerd: uitgevoerd });
    },
    scrollToOpmerkingen() {
      const el = this.$refs.opmerkingen;
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    saveOplevering() {
      console.log(this.confirmOplevering);
      console.log("saveOplevering");
      if (this.confirmOplevering && !this.heeftAuditorHandtekening) {
        // Extra beveiliging naast de disabled-knop: nooit bevestigen zonder
        // handtekening van de auditor, ook niet als de knop toch aangeklikt kan worden.
        return;
      }
      var vm = this;
      this.put(this.opleverUrl, {
        opleveringdata: {
          ...this.oplevering,
          checklist: this.list,
        },
        isGereed: this.confirmOplevering,
        uitkomstdata: this.resultaat,
      })
        .then((response) => {
          console.log(response);
          vm.$router.push({ name: "Opleveringen" });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.busy = false;
        });
    },
    getOplevering() {
      var vm = this;
      vm.busy = true;
      this.get(this.opleverUrl)
        .then(function (response) {
          console.dir(response.data);
          vm.oplevering = response.data.oplevering;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => (vm.busy = false));
    },
    tbodyTrClass(item, type) {
      if (type == "row-details") return "bg-gray-500";
      if (item.element) return "bg-gray-900";
      return;
    },
  },
};
</script>